<template>
  <div class="bar">
    <div class="bar__column bar__column--left">
      <slot name="left" />
    </div>
    <div class="bar__column bar__column--center-">
      <slot name="center" />
    </div>
    <div class="bar__column bar__column--right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bar'
}
</script>

<style lang="sass">
@import '~styles/imports'

.bar
  display: flex
  justify-content: space-between
  margin-bottom: 20px

  &__column
    width: 33%

    &--center
      display: flex
      justify-content: center

    &--right
      display: flex
      justify-content: flex-end

      .button-input
        margin-left: 10px
</style>



// WEBPACK FOOTER //
// src/components/ui/Bar.vue